import { createContext } from "react";
const WebSocketContentxt = createContext();

export default WebSocketContentxt;
